module.exports = __webpack_public_path__ + "img/Local-Storage.0f3881f1.png";